import {getFirstTeam} from "firestore/BaseFirestore";
import {Group, Person} from "models";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {PersonsGrid} from "./peopleGrid/PersonsGrid";

export function TeamSquadView() {
	const [groups, setGroups] = React.useState<Group<Person>[]>([])
	const {t} = useTranslation();

	useEffect(() => {
		getFirstTeam().then(
			(data) => {
				setGroups([
					{
						name: t("team.goalkeepers"),
						items: data.goalkeepers.sort((a, b) => (a.jerseyNumber ?? 0) - (b.jerseyNumber ?? 0))
					},
					{
						name: t("team.defenders"),
						items: data.defenders.sort((a, b) => (a.jerseyNumber ?? 0) - (b.jerseyNumber ?? 0))
					},
					{
						name: t("team.midfielders"),
						items: data.midfielders.sort((a, b) => (a.jerseyNumber ?? 0) - (b.jerseyNumber ?? 0))
					},
					{
						name: t("team.forwards"),
						items: data.forwards.sort((a, b) => (a.jerseyNumber ?? 0) - (b.jerseyNumber ?? 0))
					},
				])
			})
	}, [t])

	return (
		<PersonsGrid groups={groups}/>
	)
}
